import { DropdownItem } from './DropdownItem';
import { DropdownTypeEnum } from '../../enums/dropdownTypeEnum';

export class DropdownGroup {
    constructor(
        dropdownGroupId: number,
        eventInputDropdownGroupId: number,
        description: string,
        multiple: boolean,
        dropdownTypeId: DropdownTypeEnum,
        dropdownItemArray: DropdownItem[],
        required: boolean,
        disabled: boolean,
        disabledItemName: string
    ) {
        this.dropdownGroupId = dropdownGroupId;
        this.eventInputDropdownGroupId = eventInputDropdownGroupId;
        this.description = description;
        this.multiple = multiple;
        this.dropdownTypeId = dropdownTypeId;
        this.dropdownItemArray = dropdownItemArray;
        this.required = required;
        this.disabled = disabled;
        this.disabledItemName = disabledItemName;
    }
    dropdownGroupId: number;
    eventInputDropdownGroupId: number;
    description: string;
    multiple: boolean;
    dropdownTypeId: DropdownTypeEnum;
    dropdownItemArray: DropdownItem[];
    required: boolean;
    disabled: boolean;
    disabledItemName: string;
}
